import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export const CatalogPagination = ({ page, totalPages, pageHref, onChange }) => {
  if (totalPages <= 1) return null;
  const numbers = [...new Set([1, page - 1, page, page + 1, totalPages])]
    .filter(value => value >= 1 && value <= totalPages).sort((a, b) => a - b);
  const navigate = (event, next) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onChange(next);
  };
  const arrow = (next, direction, Icon) => {
    const disabled = next < 1 || next > totalPages;
    return <Button asChild={!disabled} disabled={disabled} variant="outline" size="icon"
      className="h-8 w-8 shrink-0" data-testid={`catalog-pagination-${direction}`}
      aria-label={direction === 'prev' ? 'Previous page of products' : 'Next page of products'}>
      {disabled ? <Icon className="h-4 w-4" /> : <Link to={pageHref(next)} rel={direction}
        onClick={event => navigate(event, next)}><Icon className="h-4 w-4" /></Link>}
    </Button>;
  };
  return <nav aria-label="Product pagination" data-testid="catalog-pagination" className="mt-8 flex flex-col items-center gap-3">
    <p data-testid="catalog-pagination-status" className="text-xs text-muted-foreground">Page {page} of {totalPages}</p>
    <div className="flex items-center justify-center gap-1">
      {arrow(page - 1, 'prev', ChevronLeft)}
      {numbers.map((number, index) => <React.Fragment key={number}>
        {index > 0 && number - numbers[index - 1] > 1 && <span aria-hidden="true" className="w-4 text-center text-xs">…</span>}
        <Button asChild size="icon" variant={number === page ? 'default' : 'outline'}
          className="h-8 w-8 shrink-0 text-xs" data-testid={`catalog-pagination-${number}`}>
          <Link to={pageHref(number)} aria-label={`Page ${number} of products`}
            aria-current={number === page ? 'page' : undefined} onClick={event => navigate(event, number)}>{number}</Link>
        </Button>
      </React.Fragment>)}
      {arrow(page + 1, 'next', ChevronRight)}
    </div>
  </nav>;
};